import axios from 'axios';

export const API_URL = process.env.REACT_APP_API_URL || 'https://api.onlywheels.org';
export const BOT_USERNAME = process.env.REACT_APP_BOT_USERNAME || 'onlywheels_bot';
export const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY || '';
export const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || '';

const api = axios.create({ baseURL: API_URL });

api.interceptors.request.use((config) => {
    const token = localStorage.getItem('token');
    if (token) config.headers.Authorization = 'Bearer ' + token;
    return config;
});

api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && error.response.status === 503) {
            const msg = error.response.data?.error || 'Site is under maintenance';
            window.dispatchEvent(new CustomEvent('maintenance', { detail: msg }));
            return Promise.reject(error);
        }
        if (error.response && error.response.status === 401) {
            const url = error.config?.url || '';
            // Don't auto-logout on login/register attempts
            if (!url.includes('/login') && !url.includes('/register')) {
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                localStorage.removeItem('is_superadmin');
                localStorage.removeItem('role');
                window.location.href = '/login';
            }
        }
        return Promise.reject(error);
    }
);

export default api;

// reCAPTCHA v3 helper
export const getCaptchaToken = async (action) => {
    if (!RECAPTCHA_SITE_KEY || !window.grecaptcha) return '';
    try {
        await new Promise(resolve => window.grecaptcha.ready(resolve));
        return await window.grecaptcha.execute(RECAPTCHA_SITE_KEY, { action });
    } catch (e) {
        console.warn('reCAPTCHA error:', e);
        return '';
    }
};
